import React, { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Radio, Checkbox, Select } from 'antd';
import './style.scss';
import PropTypes from 'prop-types';
import H3FormInput from '@Uilib/h3FormInput';
import H3Text from '@Uilib/h3Text';
import TdsTcsActions from '@Actions/configurations/tdsTcsActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import SelectTaxType from '../../../../Common/SelectTaxType';
import PRZSelect from '../../../../../Common/UI/PRZSelect';

const TdsTcsForm = ({
  getDefaultTdsTcs, getDefaultTdsTcsLoading, selectedTdsTcs, createTdsTcs, createTdsTcsLoading, updateTdsTcs, updateTdsTcsLoading, callback, defaultTdsTcs,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [taxType, setTaxType] = useState('');
  const [taxTypeName, setTaxTypeName] = useState('TDS');
  const [taxName, setTaxName] = useState('');
  const [taxValue, setTaxValue] = useState('');
  const [taxDescription, setTaxDescription] = useState('');

  useEffect(() => {
    if (selectedTdsTcs) {
      setTaxType(selectedTdsTcs?.tax_type);
      setTaxTypeName(selectedTdsTcs?.tax_type_name);
      setTaxName(selectedTdsTcs?.tax_name);
      setTaxValue(selectedTdsTcs?.tax_value);
      setTaxDescription(selectedTdsTcs?.description);
    }
  }, []);

  useEffect(() => {
    getDefaultTdsTcs(taxTypeName);
  }, [taxTypeName]);

  const addTdsTcs = () => {
    setFormSubmitted(true);
    if (taxType && taxName && taxValue && taxDescription) {
      const payload = {
        tax_id: selectedTdsTcs ? selectedTdsTcs?.tax_id : null,
        tax_name: taxName,
        tax_value: taxValue,
        tax_type: taxType,
        tax_type_name: taxTypeName,
        is_group: false,
        is_editable: true,
        description: taxDescription,
      };
      if (selectedTdsTcs) {
        updateTdsTcs(payload, () => {
          callback();
        });
      } else {
        createTdsTcs(payload, () => {
          callback();
        });
      }
    }
  };

  return (
    <Fragment>
      <div className="tdsTcs-form__wrapper">
        <div className="ant-row">

          <div className="ant-col-md-24">
            <div className="orgInputContainer">
              <div className="orgFormLabel">Type</div>
              <Radio.Group
                disabled={createTdsTcsLoading || updateTdsTcsLoading || getDefaultTdsTcsLoading || selectedTdsTcs}
                onChange={(event) => {
                  setTaxTypeName(event.target.value);
                }}
                value={taxTypeName}
              >
                <Radio value="TDS">TDS</Radio>
                <Radio value="TCS">TCS</Radio>
              </Radio.Group>
            </div>
          </div>

          <div className="ant-col-md-24 ant-col-xs-24">
            <H3FormInput
              name="tax name"
              type="text"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setTaxName(event.target.value)}
              value={taxName}
              isLoading={createTdsTcsLoading || updateTdsTcsLoading || getDefaultTdsTcsLoading}
              label="Tax Name"
              maxlength="100"
              required
              showError={formSubmitted && !taxName}
            />
          </div>

          <div className="ant-col-md-24 ant-col-xs-24">
            <H3FormInput
              name="tax value"
              type="number"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => setTaxValue(event.target.value)}
              value={taxValue}
              isLoading={createTdsTcsLoading || updateTdsTcsLoading || getDefaultTdsTcsLoading}
              label="Tax Value"
              maxlength="100"
              required
              showError={formSubmitted && !taxValue}
            />
          </div>

          <div className="ant-col-md-24 ant-col-xs-24 ">
            <div className="orgInputContainer">
              <div className="gst_treatment_input">
                <H3Text required text="Description" className="orgFormLabel" />
                <PRZSelect
                  size="middle"
                  placeholder="Select Tax Description"
                  value={taxDescription}
                  onChange={(value) => {
                    const defaultData = defaultTdsTcs?.data?.filter((item) => item?.description === value)?.[0];
                    setTaxDescription(defaultData?.description);
                    setTaxType(defaultData?.tax_type);
                  }}
                  disabled={createTdsTcsLoading || updateTdsTcsLoading || getDefaultTdsTcsLoading}
                >
                  {defaultTdsTcs?.data?.map((item, index) => (
                    <Option key={index} value={item?.description}>
                      {`${item?.description} - ${item?.tax_name}`}
                    </Option>
                  ))}
                </PRZSelect>
                {formSubmitted && !taxDescription && (
                  <div className="input-error">
                    *Please enter tax description
                  </div>
                )}
              </div>
            </div>
          </div>

        </div>
        <div className="custom-drawer__footer">
          <div className="ant-col-md-6" style={{ marginTop: '0.5rem' }}>
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text={selectedTdsTcs ? 'Update TDS/TCS' : 'Add TDS/TCS'}
              onClick={() => addTdsTcs()}
              isLoading={createTdsTcsLoading || updateTdsTcsLoading || getDefaultTdsTcsLoading}
              disabled={createTdsTcsLoading || updateTdsTcsLoading || getDefaultTdsTcsLoading}
              style={{
                width: '160px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, TdsTcsReducers }) => ({
  user: UserReducers.user,
  createTdsTcsLoading: TdsTcsReducers.createTdsTcsLoading,
  updateTdsTcsLoading: TdsTcsReducers.updateTdsTcsLoading,
  getDefaultTdsTcsLoading: TdsTcsReducers.updateTdsTcsLoading,
  defaultTdsTcs: TdsTcsReducers.defaultTdsTcs,
});

const mapDispatchToProps = (dispatch) => ({
  getDefaultTdsTcs: (taxName) => dispatch(TdsTcsActions.getDefaultTdsTcs(taxName)),
  createTdsTcs: (payload, callback) => dispatch(TdsTcsActions.createTdsTcs(payload, callback)),
  updateTdsTcs: (payload, callback) => dispatch(TdsTcsActions.updateTdsTcs(payload, callback)),
});

TdsTcsForm.propTypes = {
  getDefaultTdsTcsLoading: PropTypes.bool,
  getDefaultTdsTcs: PropTypes.func,
  createTdsTcsLoading: PropTypes.bool,
  createTdsTcs: PropTypes.func,
  updateTdsTcsLoading: PropTypes.bool,
  updateTdsTcs: PropTypes.func,
  callback: PropTypes.any,
  selectedTdsTcs: PropTypes.any,
  defaultTdsTcs: PropTypes.any,
  history: PropTypes.any,
  user: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TdsTcsForm));
